import { createSlice } from "@reduxjs/toolkit";
import { RefundOrder } from "./services/dashboardService";

interface RefundOrderState {
    refundOrders: RefundOrder[];
    loading: boolean;
    error: any;
    rowsPerPage: number;
}

const initialState: RefundOrderState = {
    refundOrders: [],
    loading: false,
    error: null,
    rowsPerPage: 10,
};

export const dashBoardSlice = createSlice({
    name: "refundOrders",
    initialState,
    reducers: {
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        clearRowsPerPage(state) {
            state.rowsPerPage = 10;
        }
    },
});

export const { setRowsPerPage, clearRowsPerPage } = dashBoardSlice.actions;

export default dashBoardSlice.reducer;
